import React, { Component } from 'react'


class SearchReceipt extends Component {
    render() {
        let receiptMap = this.props.receipt.get('text')
        const receipt = (receiptMap)
            ? receiptMap.toJS()
            : {}

        return (
            <div className="ir-search-receipt">
              { receipt.source_data_id && <div style={ { 'textAlign': 'center', 'margin': '8px' } }>
                <a
                  target="_blank"
                  title="Click to download screenshot of updated data as it appears on PACER"
                  href={`/rpc/capi/source-data/${receipt.source_data_id}/screenshot-original.pdf`}
                >
                  <i className="fa fa-camera" /> Screenshot
                </a>
              </div> }

              { receipt.screenshot && receipt.screenshot.pdf && receipt.screenshot.pdf.href && <div style={ { 'textAlign': 'center', 'margin': '8px' } }>
                <a
                  target="_blank"
                  title="Click to download screenshot of updated data as it appears on PACER"
                  href={receipt.screenshot.pdf.href}
                >
                  <i className="fa fa-camera" /> Screenshot
                </a>
              </div> }

                <table>
                    <thead>
                    <tr>
                        <th colSpan="2">PACER Service Center</th>
                    </tr>
                    </thead>
                    <tbody>

                    <tr>
                        <th>Receipt:</th>
                        <td>{ receipt.datetime }</td>
                    </tr>

                    <tr>
                        <th>User:</th>
                        <td>{ receipt.user_id && receipt.user_id.startsWith('in1524') ? "Metered Account" : "User's PACER account" }</td>
                    </tr>

                    <tr>
                        <th>Client:</th>
                        <td>{ receipt.client_code }</td>
                    </tr>

                    <tr>
                        <th>Description:</th>
                        <td>{ receipt.description }</td>
                    </tr>

                    <tr>
                        <td>&nbsp;</td>
                        <td>{ receipt.criteria }</td>
                    </tr>

                    <tr>
                        <th>Pages:</th>
                        <td>{ receipt.pages }&nbsp;(${ receipt.cost })</td>
                    </tr>

                    </tbody>
                </table>
            </div>
        )
    }
}

export default SearchReceipt



// WEBPACK FOOTER //
// ./src/components/search/results/searchReceipt/SearchReceipt.js